import { User } from "../@core/data/users";
import Course from "./course.model";

export default class Enrollment {
  id?: string;
  courseId?: string;
  tutorId?: string;
  course?: Course;
  syncOn?: Date;

  finishedOn?: Date;
  finished?: boolean;
  noSectionFinished?: number;
  noLectureFinished?: number;
  noExerciseFinished?: number;

  receivedGiftOn?: Date;
  receivedGift?: boolean;

  noComment?: number;

  noMessage?: number;
  newMessage?: boolean;

  status?: number; //1: ready, 0: pending, -1: denied
  //Render
  progress?: number;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}

export class EnrollmentSection {
  id?: string;
  enrolId?: string;
  courseId?: string;
  sectionId?: string;
  noLecture?: number;

  finishedOn?: Date;
  finished?: boolean;
  noLectureFinished?: number;

  enrolLectures?: EnrollmentLecture[];

  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}

export class EnrollmentLecture {
  id?: string;
  enrolId?: string;
  courseId?: string;
  sectionId?: string;
  lectureId?: string;

  finishedOn?: Date;
  finished?: boolean;

  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
